import * as tus from 'tus-js-client';
import toQueryParams from '../../utils/toQueryParams';
import claimScoreApiServiceClient, { getAuthorizationToken } from '../client';
import { FilesPaginated } from '../shared/types';
import {
  ClaimFiles,
  GetAllFilesPayload,
  GetSuperAdminClaimResultsPayload,
  GetSuperAdminClaimResultsResponse,
  SubmitBulkUploadFileParams,
  UpdateClaimFilesPayload,
} from './types';

const baseURL = import.meta.env.VITE_CLAIMSCORE_API_URL;

export const getSuperAdminClaimResults = async ({
  caseID,
  ...payload
}: GetSuperAdminClaimResultsPayload): Promise<GetSuperAdminClaimResultsResponse> => {
  const { data } = await claimScoreApiServiceClient.post(
    `/files/${caseID}/claims-results-super-admin`,
    payload,
    { responseType: 'blob' },
  );
  return data;
};

export const submitBulkUploadFile = async ({
  file,
  caseID,
  uploaderEmail,
  containsHeader,
  headers,
  delimiter,
  escapeChar,
  onProgress,
  onSuccess,
  onError,
}: SubmitBulkUploadFileParams) => {
  const authToken = await getAuthorizationToken();
  const upload = new tus.Upload(file, {
    endpoint: `${baseURL}/bulk-upload/uploads/files`,
    metadata: {
      fileSize: file.size.toString(),
      fileName: file.name,
      fileType: file.type,
      caseID,
      uploaderEmail,
      delimiter,
      escapeChar,
      containsHeader,
      headers,
    },
    headers: {
      authorization: authToken,
      'x-case-id': caseID,
    },
    onError(error) {
      if (onError) onError(error);
    },
    onProgress(bytesUploaded, bytesTotal) {
      const percentage = (bytesUploaded / bytesTotal) * 100;
      if (onProgress) onProgress(percentage);
    },
    onSuccess() {
      if (onSuccess) {
        onSuccess(upload);
      }
    },
  });

  upload.start();
};

export const getAllFiles = async ({
  pageNumber,
  pageSize,
  sortOrder,
  sortField,
  users,
  status,
  caseID,
}: GetAllFilesPayload): Promise<FilesPaginated<ClaimFiles>> => {
  const { data } = await claimScoreApiServiceClient.get(
    `/files/${caseID}?${toQueryParams({
      pageNumber,
      pageSize,
      sortOrder,
      sortField,
      users,
      status,
    })}`,
  );

  return data;
};

export const deleteListOfFiles = async (caseID: string, fileIDs: string[]) => {
  const { data } = await claimScoreApiServiceClient.delete(`/files/${caseID}`, {
    data: { fileIDs },
  });
  return data;
};

export const updateFile = async ({
  caseID,
  fileID,
  fileStatus,
  enabledStatus,
}: UpdateClaimFilesPayload) => {
  const { data } = await claimScoreApiServiceClient.put(
    `/files/${caseID}/${fileID}`,
    {
      fileStatus,
      enabledStatus,
    },
  );
  return data;
};
